import React from 'react';
import MaskedInput from 'react-text-mask';
import { InputBaseComponentProps } from '@material-ui/core/InputBase';

interface Props extends InputBaseComponentProps {
  maskPlaceholder?: string;
}

const MaskedInputComponent: React.FC<Props> = ({ inputRef, mask, maskPlaceholder, value, ...other }) => {
  let maskArray: false | Array<string | RegExp> = false;

  switch (mask) {
    case 'phone':
      if (value && value.startsWith('+')) {
        maskArray = ['+', /[1-9]/, ' ', /[1-9]/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
      } else if (value !== '') {
        maskArray = [/[1-9]/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
      }
      break;
    case 'date':
      maskArray = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/];
      break;
    default:
      maskArray = typeof mask !== 'string' ? mask : false;
  }

  return (
    // @ts-ignore
    <MaskedInput
      guide={false}
      mask={maskArray}
      placeholder={maskPlaceholder}
      placeholderChar={!maskPlaceholder ? '\u2000' : undefined}
      ref={(ref: unknown) => {
        inputRef.current = ref; // eslint-disable-line no-param-reassign
      }}
      value={value}
      {...other}
    />
  );
};

export default MaskedInputComponent;
